import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

interface WatchlistHeaderProps {
  totalCount: number;
}

/**
 * Watchlist 下拉菜单头部组件
 * 显示标题和总条目数
 */
export function WatchlistHeader({ totalCount }: WatchlistHeaderProps) {
  const { t } = useTranslation('chrome');
  return (
    <div className="flex items-center justify-between px-4 py-3 border-b">
      <h3 className="text-sm font-semibold">{t('watchlist.title')}</h3>
      <Badge variant="secondary" className="text-xs">
        {totalCount}
      </Badge>
    </div>
  );
}
